/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import Loader from '@engine/components/presentational/base/loader';

function ButtonsToolbar(_ref) {
  var backHref = _ref.backHref,
      isSaving = _ref.isSaving,
      onReset = _ref.onReset,
      onSave = _ref.onSave,
      disableUndoButton = _ref.disableUndoButton;
  return React.createElement("div", {
    className: "buttons-toolbar"
  }, React.createElement("a", {
    href: backHref,
    className: "btn btn-back ".concat(isSaving ? 'disabled' : '')
  }, I18n.t('actions.default.back')), React.createElement("div", null, React.createElement("button", {
    className: "btn btn-reset",
    type: "button",
    disabled: isSaving || disableUndoButton,
    onClick: onReset
  }, I18n.t('actions.default.undo')), isSaving ? React.createElement(Loader, {
    position: "horizontal-center",
    message: I18n.t('javascript.saving_in_progress'),
    color: "refined-green"
  }) : React.createElement("button", {
    className: "btn btn-save",
    type: "button",
    disabled: isSaving,
    onClick: onSave
  }, I18n.t('actions.default.save'))));
}

export default ButtonsToolbar;